<script setup>
import MaterialTag from '@/components/create/material/MaterialTag.vue';

const props = defineProps({
  assets: Array,
});

const emit = defineEmits(['click', 'remove']);

function removeAsset(asset) {
  const index = props.assets.findIndex((a) => a.id === asset.id);
  if (index > -1) {
    props.assets.splice(index, 1);
  }
}
</script>

<template>
  <div class="flex flex-wrap gap-2" @click="emit('click')">
    <MaterialTag v-for="asset in assets" :key="asset.id" :asset="asset" @remove="removeAsset" />
  </div>
</template>
